import { useMemo } from 'react';

import { TFilterFormValues } from 'common/types';
import { useUrlFilterParams } from 'common/hooks/useUrlFilterParams';
import {
    filtersToBase64String,
    filtersToQueryParams,
} from 'common/utils/filter';
import { getUserBudgetRequestFilters } from 'budget/utils/filter';
import { IUserBudgetRequestsFilterValues } from 'budget/types';

export const useUserBudgetRequestsFilter = (filterParamsInUrl = true) => {
    const { filterParams, setFilterParam } = useUrlFilterParams(
        'budget',
        filterParamsInUrl
    );

    const filters = getUserBudgetRequestFilters();

    const searchQueryParam = filterParams.q || '';
    const selectedFilterParams = filterParams.filters;

    const handleSearch = (searchValue: string) => {
        setFilterParam('q', searchValue);
    };

    const handleFilterChange = (values?: TFilterFormValues) => {
        const filterString = filtersToBase64String(filters, values);

        setFilterParam('filters', filterString);
    };

    const selectedFilters: Partial<IUserBudgetRequestsFilterValues> =
        useMemo(() => {
            if (!selectedFilterParams) return {};

            try {
                return JSON.parse(window.atob(selectedFilterParams));
            } catch {
                return {};
            }
        }, [selectedFilterParams]);

    const filterValuesForQuery = useMemo(
        () =>
            filtersToQueryParams<IUserBudgetRequestsFilterValues>(
                filters,
                selectedFilters
            ),
        [selectedFilters]
    );

    return {
        filters,
        filterValues: { ...selectedFilters, q: searchQueryParam },
        filterValuesForQuery,
        handleSearch,
        handleFilterChange,
    };
};
